// extracted by mini-css-extract-plugin
export default {"Container":"PricingBlock_Container__YIXds"};